import React, { useMemo, useState } from "react";
import Popover from "@mui/material/Popover";
import commonImages from "../../../assets";
import {
  Card,
  CardContent,
  Box,
  CardActions,
  FormGroup,
  FormControlLabel,
  Typography,
  Grid,
} from "@mui/material";
import Buttons from "../../../library/custom/button/Button";
import FormLabels from "../../../library/custom/formLabel/FormLabels";
import SelectMenu from "../../../library/custom/selectMenu/SelectMenu";
import "./FilterCommonStatusSelect.scss";
import DatePicker from "../../../library/custom/datePicker/DatePicker";
import {
  ACTIVE_INACTIVE,
  IS_RECORDALE,
  IS_SCORM_COURSE_STATUS,
  MAPPED,
  YES_NO,
} from "../../../constant/constant";
import Checkbox from "../../../library/checkbox/checkbox";
import FormControl from "@mui/material/FormControl";
import { sortAlphabetically } from "../../../utils/helper";

const FilterCommonStatusSelect = ({
  id,
  open,
  anchorEl,
  handleClose,
  statusType,
  categoryType,
  category,
  handleApply,
  handleClear,
  resetBtn = false,
  filter,
  categoryOnChanges,
  onChangeType,
  filterSelect = false,
  filterStatus = false,
  label = "Status",
  selectLable,
  filterDate = false,
  toDate,
  fromDate,
  onchangeToDatePicker,
  onchangeFromDatePicker,
  minDate = false,
  scalculatedDate = "",
  statusId = "",
  frequencySelect = false,
  frequencyLable,
  frequencyType,
  frequencyId,
  frequencyOnChanges,
  expirationType,
  expirationTypeOnChanges,
  expirationTypeList = null,
  scheduledTypeOnChanges,
  scheduledTypeList,
  isAssigned,
  ispastMeetingTab = false,
  filterIsRecordaleSelect = false,
  isRecordaleLable,
  isRecordale,
  isRecordaleOnChanges,
  spacing = { pb: 2, pt: 2 },
  filterMap = false,
  mappedOnChanges,
  isMapped,
  activeInActive,
  statusCheckbox = false,
  handleActiveInActiveChange,
  filterIsCourseScormStatus = false,
  IsScormCourseStatus,
  isScormCourseOnChanges,
  isDivistionFilter = false,
  firstLebelFilter,
  firstLebelValue,
  firstLebelOnChanges,
  disableDivision,
  statusFilterSelect = false,
  statusSelectLable,
  statusCategoryType,
  statusCategory,
  statusCategoryOnChanges,
}) => {
  const sortedcategoryType = useMemo(() => {
    return sortAlphabetically(categoryType);
  }, [categoryType]);

  const sortedExpirationTypeList = useMemo(() => {
    return sortAlphabetically(expirationTypeList);
  }, [expirationTypeList]);

  const sortedMapped = useMemo(() => {
    return sortAlphabetically(MAPPED);
  }, [MAPPED]);

  const sortedFirstLebelFilter = useMemo(() => {
    return sortAlphabetically(firstLebelFilter);
  }, [firstLebelFilter]);

  const sortedStatusCategoryType = useMemo(() => {
    return sortAlphabetically(statusCategoryType);
  }, [statusCategoryType]);

  return (
    <>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Card className="filterlist_of_cases">
          <CardContent>
            {filterDate && (
              <>
                <Box className="" sx={{ pb: 2 }}>
                  <Typography className="filterLabel" gutterBottom variant="h5">
                    Time Period
                  </Typography>
                  <Box className="datePicker_row">
                    <div>
                      <Typography variant="subtitle1">From</Typography>
                      <DatePicker
                        value={fromDate}
                        onChangeHandler={(e) => onchangeFromDatePicker(e)}
                        maxDateEnable
                      />
                    </div>
                    <div>
                      <Typography variant="subtitle1">To</Typography>
                      <DatePicker
                        value={toDate}
                        onChangeHandler={(e) => onchangeToDatePicker(e)}
                        maxDateEnable={
                          scalculatedDate && statusId === 9 ? false : true
                        }
                        minDate={fromDate}
                        maxDate={scalculatedDate ?? ""}
                      />
                    </div>
                  </Box>
                </Box>

                {ispastMeetingTab && (
                  <>
                    {" "}
                    <Box className="" sx={{ pb: 2, pt: 2 }}>
                      <FormLabels
                        label={selectLable ? selectLable : "Scheduled"}
                        isRequired={false}
                      />
                      <SelectMenu
                        name={"Scheduled"}
                        listData={scheduledTypeList}
                        onchangehandler={(e) => scheduledTypeOnChanges(e)}
                        value={isAssigned}
                        placeholder="Please select"
                      />
                    </Box>
                  </>
                )}
              </>
            )}

            {filterStatus && (
              <Box className="custom_filter_box">
                <FormGroup>
                  <FormLabels label={label} isRequired={false} />

                  {statusType &&
                    statusType.map((item) => (
                      <FormControlLabel
                        key={item.key}
                        control={
                          <img
                            className="filterCheckbox"
                            title={
                              filter.searchType[0]?.key === item.key
                                ? "tickCheckbox"
                                : "untickCheckbox"
                            }
                            alt=""
                            src={
                              filter.searchType[0]?.key === item.key
                                ? commonImages.check
                                : commonImages.noCheck
                            }
                            onClick={() => onChangeType(item)}
                          />
                        }
                        label={item?.value}
                      />
                    ))}
                </FormGroup>
              </Box>
            )}
            {expirationTypeList && (
              <Box className="" sx={{ pb: 2, pt: 2 }}>
                <FormLabels
                  label={selectLable ? selectLable : "Expiry"}
                  isRequired={false}
                />
                <SelectMenu
                  name={"expirationType"}
                  listData={sortedExpirationTypeList}
                  onchangehandler={(e) => expirationTypeOnChanges(e)}
                  value={expirationType}
                  placeholder="Please select"
                />
              </Box>
            )}
            {filterSelect && (
              <Box className="" sx={spacing}>
                {statusCheckbox && (
                  <Grid mb={2}>
                    <FormControl fullWidth>
                      <FormLabels label={"Category Status"} />
                      <div className="customSelectMethod">
                        <div>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={activeInActive[ACTIVE_INACTIVE.ACTIVE]}
                                onChange={(event) =>
                                  handleActiveInActiveChange(event)
                                }
                                value={ACTIVE_INACTIVE.ACTIVE}
                                label="Active"
                              />
                            }
                          />
                        </div>
                        <div>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  activeInActive[ACTIVE_INACTIVE.INACTIVE]
                                }
                                onChange={(event) =>
                                  handleActiveInActiveChange(event)
                                }
                                value={ACTIVE_INACTIVE.INACTIVE}
                                label={"InActive"}
                              />
                            }
                          />
                        </div>
                      </div>
                    </FormControl>
                  </Grid>
                )}
                <FormLabels
                  label={selectLable ? selectLable : "Category"}
                  isRequired={false}
                />
                <SelectMenu
                  name={"Category"}
                  listData={sortedcategoryType}
                  onchangehandler={(e) => categoryOnChanges(e)}
                  value={category}
                  placeholder="Please select"
                />
              </Box>
            )}
            {filterMap && (
              <Box className="" sx={spacing}>
                <FormLabels label={"Mapped"} isRequired={false} />
                <SelectMenu
                  name={"mapped"}
                  listData={sortedMapped}
                  onchangehandler={(e) => mappedOnChanges(e)}
                  value={isMapped}
                  placeholder="Please select"
                />
              </Box>
            )}
            {filterIsRecordaleSelect && (
              <Box>
                <FormLabels
                  label={isRecordaleLable ? isRecordaleLable : "Category"}
                  isRequired={false}
                />
                <SelectMenu
                  name={"isRecordale"}
                  listData={IS_RECORDALE}
                  onchangehandler={(e) => isRecordaleOnChanges(e)}
                  value={isRecordale}
                  placeholder="Please select"
                />
              </Box>
            )}
            {isDivistionFilter && (
              <Box>
                <FormLabels label={"Division "} isRequired={false} />
                <SelectMenu
                  name={"Division"}
                  listData={sortedFirstLebelFilter}
                  onchangehandler={(e) => firstLebelOnChanges(e)}
                  value={firstLebelValue}
                  placeholder="Please select"
                  disabled={disableDivision}
                />
              </Box>
            )}
            {statusFilterSelect && (
              <Box className="" sx={spacing}>
                <FormLabels
                  label={statusSelectLable ? statusSelectLable : "Status"}
                  isRequired={false}
                />
                <SelectMenu
                  name={"status"}
                  listData={sortedStatusCategoryType}
                  onchangehandler={(e) => statusCategoryOnChanges(e)}
                  value={statusCategory}
                  placeholder="Please select"
                />
              </Box>
            )}
            {filterIsCourseScormStatus && (
              <Box className="" sx={spacing}>
                <FormLabels label={"Status"} isRequired={false} />
                <SelectMenu
                  name={"status"}
                  listData={IS_SCORM_COURSE_STATUS}
                  onchangehandler={(e) => isScormCourseOnChanges(e)}
                  value={IsScormCourseStatus}
                  placeholder="Please select"
                />
              </Box>
            )}
            {frequencySelect && (category === 1 || category === 3) && (
              <Box className="" sx={{ pb: 2, pt: 2 }}>
                <FormLabels label={frequencyLable} isRequired={false} />
                <SelectMenu
                  name={"Category"}
                  listData={frequencyType}
                  onchangehandler={(e) => frequencyOnChanges(e)}
                  value={frequencyId}
                  placeholder="Please select"
                />
              </Box>
            )}
          </CardContent>
          <CardActions>
            {resetBtn && (
              <Buttons
                primary={true}
                label={"Reset"}
                onClick={(e) => handleClear(e)}
                size="small"
              />
            )}

            <Buttons
              primary={true}
              label={"Apply"}
              onClick={(e) => handleApply(e)}
              size="small"
            />
          </CardActions>
        </Card>
      </Popover>
    </>
  );
};

export default FilterCommonStatusSelect;
